module.exports = __webpack_public_path__ + "static/media/rsz_klaytn.0c19dda3.webp";